import React from 'react';

import * as S from './styles';

interface Props {
  text: string;
  className?: string;
}

export const SectionHeadline: React.FC<Props> = ({ text, className }) => {
  return <S.Headline className={className}>{text}</S.Headline>;
};

export default SectionHeadline;
